/* CYC battery shipping guard: batteries are limited to one per order (lithium
   shipping regulations, ~11.5kg). Liquid renders the notice + a hidden flag in
   the cart regions Shopify re-renders on quantity change; this script mirrors
   that state onto the checkout buttons that live OUTSIDE those regions (mobile
   sticky bar, cart-drawer footer) and hides express/dynamic checkout buttons
   that would bypass the cart.

   Re-sync triggers, most reliable first:
   - the theme's own `cart:change` / `line-item:change` document events (fired by
     cart.js after every quantity update, in both the cart page and the drawer);
   - a MutationObserver fallback for any other cart re-render. */
(function () {
  if (window.__batteryGuardInit) return;
  window.__batteryGuardInit = true;

  function isOver() {
    return !!document.querySelector('.battery-guard-flag[data-battery-over="true"]');
  }

  function apply() {
    var over = isOver();
    document.querySelectorAll('button[name="checkout"], .cart__mobile-bar-checkout').forEach(function (btn) {
      if (over) {
        if (!btn.disabled) { btn.disabled = true; btn.dataset.batteryDisabled = '1'; }
        btn.classList.add('is-battery-blocked');
      } else {
        if (btn.dataset.batteryDisabled) { btn.disabled = false; delete btn.dataset.batteryDisabled; }
        btn.classList.remove('is-battery-blocked');
      }
    });
    document.querySelectorAll('.cart__footer-dynamic-checkout, .additional-checkout-buttons').forEach(function (el) {
      el.style.display = over ? 'none' : '';
    });
    // keep the custom mobile sticky-bar total in sync with the re-rendered cart total
    var sub = document.querySelector('#main-cart-footer .totals__subtotal-value, .js-contents-totals .totals__subtotal-value');
    var mob = document.querySelector('.cart__mobile-bar-price');
    if (sub && mob) mob.textContent = sub.textContent.trim();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var run = function () { scheduled = false; apply(); };
    // defer past the current tick so the section re-render (which runs right
    // after cart:change is dispatched) has replaced the flag before we read it.
    if (window.requestAnimationFrame) window.requestAnimationFrame(function () { setTimeout(run, 0); });
    else setTimeout(run, 30);
  }

  // Primary: the theme's cart events (cart page + drawer)
  document.addEventListener('cart:change', schedule);
  document.addEventListener('line-item:change', schedule);
  // Fallback: any other DOM re-render of the cart
  try { new MutationObserver(schedule).observe(document.body, { subtree: true, childList: true }); } catch (e) {}

  if (document.readyState !== 'loading') apply();
  document.addEventListener('DOMContentLoaded', apply);
})();
